import type { BadgeParams } from '../store';

const WALL = 1.5;
const CLUSTER_HALF_WIDTH = 1.625;
const CLUSTER_CENTRE_X = 0.625;

export const MOTIF_BUBBLES: { r: number; x: number; y: number }[] = [
  { r: 1, x: -CLUSTER_CENTRE_X, y: 0 },
  { r: 0.5, x: 1.2 - CLUSTER_CENTRE_X, y: 0.4 },
  { r: 0.35, x: 1.9 - CLUSTER_CENTRE_X, y: -0.3 },
];

export function cornerInsets(p: Pick<BadgeParams, 'width' | 'height' | 'cornerHoleRadius'>): { x: number; y: number } {
  return {
    x: Math.max(p.width / 2 - p.cornerHoleRadius - 2, 1),
    y: Math.max(p.height / 2 - p.cornerHoleRadius - 2, 1),
  };
}

export function fittedMotifRadius(p: BadgeParams): number {
  const holeClearX = cornerInsets(p).x - p.cornerHoleRadius - WALL;
  const halfWidth = p.engrave ? CLUSTER_HALF_WIDTH : 1;
  const limit = Math.min(p.height / 2 - WALL, holeClearX / halfWidth);
  return Math.max(0, Math.min(p.motifRadius, Math.floor(limit * 2) / 2));
}
